import React from 'react';
import { Backdrop, CircularProgress } from '@mui/material';

interface LoadingProps {
  open: boolean;
}

const UpdateTitleLoading: React.FC<LoadingProps> = ({ open }) => {
  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1000
      }}
      open={open}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default UpdateTitleLoading;
